import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import SelectedSticker from "./views/SelectedSticker.vue";
import Register from "./views/Register.vue";
import Login from "./views/Login.vue";
import LoginCheckout from "./views/LoginCheckout.vue";
import Dashboard from "./views/Dashboard.vue";
import Orders from "./views/Orders.vue";
import Admin from "./views/Admin.vue";
import AdminUsers from "./views/AdminUsers.vue";
import AdminOrders from "./views/AdminOrders.vue";
import AdminStickers from "./views/AdminStickers.vue";
import AdminAddSticker from "./views/AdminAddSticker.vue";
import AdminSelectedUser from "./views/AdminSelectedUser.vue";
import AdminSelectedSticker from "./views/AdminSelectedSticker.vue";
import AdminSelectedOrder from "./views/AdminSelectedOrder.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import ChangePassword from "./views/ChangePassword.vue";
import Cart from "./views/Cart.vue";
import CheckoutAddress from "./views/CheckoutAddress.vue";
import Charge from "./views/Charge.vue";
import Confirmation from "./views/Confirmation.vue";
import AddressBook from "./views/AddressBook.vue";
import EditAddress from "./views/EditAddress.vue";
import AddNewAddress from "./views/AddNewAddress.vue";
import FAQs from "./views/FAQs.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/faqs",
      name: "faqs",
      component: FAQs
    },
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/loginCheckout",
      name: "loginCheckout",
      component: LoginCheckout
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin
    },
    {
      path: "/adminUsers",
      name: "adminUsers",
      component: AdminUsers
    },
    {
      path: "/adminStickers",
      name: "adminStickers",
      component: AdminStickers
    },
    {
      path: "/adminOrders",
      name: "adminOrders",
      component: AdminOrders
    },
    {
      path: "/adminAddSticker",
      name: "adminAddSticker",
      component: AdminAddSticker
    },
    {
      path: "/adminSelectedUser",
      name: "adminSelectedUser",
      component: AdminSelectedUser
    },
    {
      path: "/adminSelectedSticker",
      name: "adminSelectedSticker",
      component: AdminSelectedSticker
    },
    {
      path: "/adminSelectedOrder",
      name: "adminSelectedOrder",
      component: AdminSelectedOrder
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgotPassword
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: ChangePassword
    },
    {
      path: "/selectedSticker",
      name: "selectedSticker",
      component: SelectedSticker
    },
    {
      path: "/cart",
      name: "cart",
      component: Cart
    },
    {
      path: "/CheckoutAddress",
      name: "CheckoutAddress",
      component: CheckoutAddress
    },
    {
      path: "/charge",
      name: "Charge",
      component: Charge
    },
    {
      path: "/confirmation",
      name: "Confirmation",
      component: Confirmation
    },
    {
      path: "/addressBook",
      name: "AddressBook",
      component: AddressBook
    },
    {
      path: "/editAddress",
      name: "EditAddress",
      component: EditAddress
    },
    {
      path: "/addNewAddress",
      name: "AddNewAddress",
      component: AddNewAddress
    }
  ]
});
